import { AppState } from '../../app-state/app-state';

export const getAccountsState = (state: AppState) => state.accounts;
